import { Button, type ButtonVariant, type MantineSpacing } from "@mantine/core";
import { IconDeviceFloppy } from "@tabler/icons-react";

type SaveButtonProps = {
  maw?: MantineSpacing;
  label: string;
  disabled?: boolean;
  variant?: ButtonVariant;
};

export function SaveButton({ maw = "100%", label, disabled = false, variant = "filled" }: SaveButtonProps) {
  return (
    <Button disabled={disabled} maw={maw} type="submit" leftSection={<IconDeviceFloppy />} variant={variant}>
      {label}
    </Button>
  );
}
